import { useTrackEvent, ANALYTICS_EVENTS } from '@resida/analytics';

const isPreLaunch = import.meta.env.VITE_PRE_LAUNCH === 'true';

export function CTABanner(): JSX.Element {
  const trackEvent = useTrackEvent();

  return (
    <section
      data-testid="cta-banner"
      className="py-[var(--landing-section-py)] bg-[var(--landing-bg)]"
    >
      <div className="max-w-[var(--landing-container-max)] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[var(--landing-text-primary)] mb-4">
          Ready to simplify your rental management?
        </h2>
        <p className="text-lg text-[var(--landing-text-muted)] max-w-xl mx-auto mb-8">
          Free trial. No credit card required. Set up in minutes.
        </p>
        <div hidden={isPreLaunch}>
          <a
            href="/landlord/login"
            data-testid="cta-banner-button"
            className="inline-flex items-center justify-center min-h-[44px] px-8 py-3 rounded-[var(--landing-radius)] bg-[var(--landing-accent)] hover:bg-[var(--landing-accent-hover)] text-white text-base font-semibold transition-colors shadow-[var(--landing-shadow)]"
            onClick={() => trackEvent(ANALYTICS_EVENTS.LANDING_CTA_CLICKED, { location: 'closing_banner' })}
          >
            Start Free Trial
          </a>
        </div>
      </div>
    </section>
  );
}
